import styled, { css } from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

export const Container = styled.div`
  width: 100%;
`;

export const AutosizeTextarea = styled(TextareaAutosize)`
  ${({ theme }) => css`
    width: 100%;
    min-height: 100px;
    resize: none;
    border: 1.5px solid ${theme.colors.base.border};
    border-radius: 0.75rem;
    padding: 0.875rem 1rem;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: ${theme.colors.foreground[100]};
    background: ${theme.colors.background[80]};
    transition: ${theme.transition.default};

    :focus {
      border-color: ${theme.colors.brand.primary.default};
      background: ${theme.colors.background[100]};
      box-shadow: 0 0 0 3px ${theme.colors.brand.primary.opaque};
      outline: none;
    }

    ::placeholder {
      font-weight: 400;
      color: ${theme.colors.foreground[40]};
    }
  `}
`;
